/* FREEZE BODY HELPERS START */
function syncBodyHeight() {
    document.documentElement.style.setProperty(
        "--window-inner-height",
        `${window.innerHeight}px`
    );
}

function getMobileOperatingSystem() {
    var isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    var isMacLike = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i)
        ? true
        : false;
    var isIOS = navigator.platform.match(/(iPhone|iPod|iPad)/i) ? true : false;
    if (isMac || isMacLike || isIOS) {
        return "IOS";
    }
    return "OTHER";
}


function freezeBody() {
    let body = document.body;
    if (getMobileOperatingSystem() == "IOS") {
        body.classList.add("freeze-body-ios");
        window.addEventListener("resize", syncBodyHeight);
    } else {
        body.classList.add("freeze-body");
        document.documentElement.style.overflow = "hidden";
    }
}
function unfreezeBody() {
    let body = document.body;
    if (getMobileOperatingSystem() == "IOS") {
        body.classList.remove("freeze-body-ios");
        window.removeEventListener("resize", syncBodyHeight);
    } else {
        body.classList.remove("freeze-body");
        document.documentElement.style.overflow = "unset";
    }
}

/* FREEZE BODY HELPERS END */




/* sticky menu start */
const menu = document.querySelector('header');
const scroll = () => {
    const offsetY = window.offsetY || window.pageYOffset

    if (offsetY > menu.getBoundingClientRect().height / 2) {
        menu.classList.add('stick')
    } else {
        menu.classList.remove('stick')
    }
}

const onLoadAway = () => {
    const offsetY = window.offsetY || window.pageYOffset
    if (offsetY > menu.getBoundingClientRect().height / 2) {
        menu.classList.add('is-away')
    }
}

const setupStickyMenu = () => {
    let prevScrollPos = window.pageYOffset || document.documentElement.scrollTop

    window.addEventListener('scroll', function () {
        const currentScrollPos =
            window.pageYOffset || document.documentElement.scrollTop

        if (
            currentScrollPos > menu.getBoundingClientRect().height / 2 &&
            currentScrollPos > prevScrollPos
        ) {
            menu.classList.add('is-away')
        } else {
            menu.classList.remove('is-away')
        }

        prevScrollPos = currentScrollPos
    })
}
/* sticky menu end */



/* dropdown menu start */

const initMobileMenu = () => {
    const mobileMenu = document.querySelector('.js-menu-mobile');

    const closers = document.querySelectorAll('.js-menu-hide');

    closers.forEach(element => {
        element.addEventListener('click', () => {
            mobileMenu.style.transform = "translateX(100%)";
            unfreezeBody()
        });
    });

    document.querySelector('.js-menu-show').addEventListener('click', () => {
        mobileMenu.style.transform = "translateX(0%)";
        freezeBody();
    });


    // HIDE STICKY MENU IF SCROLLING TO AN ANOCHR ON SCROLLEND
    function onScrollEnd() {
        console.log("the scroll is over")
        menu.classList.add('is-away');
        // Remove the event listener
        window.removeEventListener("scrollend", onScrollEnd);
    }
    const mobileMenulinks = document.querySelectorAll('.js-mobile-menu-link');
    mobileMenulinks.forEach(element => {
        element.addEventListener('click', () => { window.addEventListener("scrollend", onScrollEnd) });
    });


};

/* dropdown menu end */

const initMenu = () => {
    scroll()
    window.addEventListener('scroll', () => scroll())
    setupStickyMenu()
    onLoadAway()
    initMobileMenu()
}

export { initMenu }
